import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { styled } from "@mui/material/styles";
import { NodelMasterData } from "types/models/nodelMaster/NodelMasterApp";

const StyledTableCell = styled(TableCell)(() => ({
  fontSize: 14,
  padding: 8,
  textAlign: "left",
  minWidth: 150,
  maxWidth: 150,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  "&:first-of-type": {
    paddingLeft: 20,
  },
  "&:last-of-type": {
    paddingRight: 20,
  },
}));

interface TableItemProps {
  data: NodelMasterData;
}

const TableItem: React.FC<TableItemProps> = ({ data }) => {
  return (
    <TableRow key={data.id} className="item-hover">
      <StyledTableCell title={data.createdAt}>{data.createdAt}</StyledTableCell>
      <StyledTableCell title={data.customerId}>{data.customerId}</StyledTableCell>
      <StyledTableCell title={data.ticketId}>{data.ticketId}</StyledTableCell>
      <StyledTableCell title={data.message}>{data.message}</StyledTableCell>
      <StyledTableCell title={data.source}>{data.source}</StyledTableCell>
      <StyledTableCell title={data.reference}>{data.reference}</StyledTableCell>
      <StyledTableCell title={data.name}>{data.name}</StyledTableCell>
      <StyledTableCell title={data.mobile}>{data.mobile}</StyledTableCell>
      <StyledTableCell title={data.email}>{data.email}</StyledTableCell>
    </TableRow>
  );
};

export default TableItem;
